export async function generateKey() {
  return window.crypto.subtle.generateKey(
    { name: 'AES-GCM', length: 256 },
    true,
    ['encrypt', 'decrypt']
  )
}

export async function encryptBlob(blob, key) {
  const iv = window.crypto.getRandomValues(new Uint8Array(12))
  const buffer = await blob.arrayBuffer()
  const encrypted = await window.crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    key,
    buffer
  )
  return { encryptedBuffer: encrypted, iv }
}

export async function decryptBuffer(encryptedBuffer, key, iv) {
  return window.crypto.subtle.decrypt(
    { name: 'AES-GCM', iv },
    key,
    encryptedBuffer
  )
}

export async function exportKeyToBase64(key) {
  const raw = await window.crypto.subtle.exportKey('raw', key)
  return arrayBufferToBase64(raw)
}

export async function importKeyFromBase64(base64) {
  const raw = base64ToArrayBuffer(base64)
  return window.crypto.subtle.importKey(
    'raw',
    raw,
    { name: 'AES-GCM' },
    false,
    ['decrypt']
  )
}

export function buildTransferUrl(baseUrl, fileId, keyB64, ivB64, mimeType) {
  return (
    baseUrl +
    '/receive#' +
    keyB64 +
    ':' +
    ivB64 +
    ':' +
    encodeURIComponent(mimeType) +
    ':' +
    fileId
  )
}

export function parseTransferFragment(fragment) {
  const raw = fragment.startsWith('#') ? fragment.slice(1) : fragment
  const [keyBase64, ivBase64, encodedMime, fileId] = raw.split(':')
  return {
    keyBase64,
    ivBase64,
    mimeType: decodeURIComponent(encodedMime),
    fileId,
  }
}

export function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return btoa(binary)
}

export function base64ToArrayBuffer(base64) {
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes.buffer
}

export function ivToBase64(iv) {
  return arrayBufferToBase64(iv.buffer)
}

export function base64ToIv(base64) {
  return new Uint8Array(base64ToArrayBuffer(base64))
}
